export const siteSettings = {
  name: "Exchange Markets",
  link: "https://exchangemarkets.live",
  email: "support@exchangemarkets.live",
  appLink: "https://app.exchangemarkets.live",
};
